<template>
  <div>
    <div class="h-[400px]">
      <div class="px-4 pb-0 pt-0 h-full overflow-auto">
        <div class="h-full border border-solid border-[#d9d9d9]">
          <div class="h-full">
            <div class="h-full">
              <el-tabs class="tabs h-full">
                <el-tab-pane v-for="source in sources" :key="source.type">
                  <span slot="label">{{ source.name }}</span>
                  <template v-if="source.items.length > 0">
                    <div v-for="item in source.items" :key="item.id">
                      <div
                        style="height: 34px;line-height: 34px;"
                        :class="[{'bg-[#e6f7f6]': item.id === form.id}, 'px-2', 'cursor-pointer']" @click="onClick(item)"
                      >
                        <span class="flex justify-between h-full">
                          <span class="text-sm flex items-center">
                            <span class="node-icon">
                              <i class="bi bi-cart" style="color: rgb(245, 164, 57);" />
                            </span>
                            <span class="pl-2">{{ item.name }}</span>
                          </span>
                          <span v-show="item.id === form.id" class="flex items-center text-[#409EFF] text-lg"><i
                            class="bi bi-check-circle-fill"
                          /></span>
                        </span>
                      </div>
                    </div>
                  </template>
                  <el-empty v-else :description="source.desc" :image-size="100">
                    <el-button>新建{{ source.name }}</el-button>
                  </el-empty>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="px-[14px] py-5">
      <div class="text-right">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import zroute from '../../ziggy'

export default {
  name: 'DataSourceSelect',
  props: {
    value: {
      type: Object,
      default: () => ({}),

    },
  },
  data() {
    return {
      form: this.value,
      sources: [
        {
          // items: [{id: '1', name: '表单1'}, {id: '2', name: '表单2'}],
          items: [],
          name: '表单',
          type: 'form',
          desc: '表单可以收集数据，流程表单适用于报销、审批等工作流。',
        },
        {
          // items: [{id: '3', name: '数据流1'}, {id: '4', name: '数据流2'}],
          items: [],
          name: '数据流',
          type: 'flow',
          desc: '数据流可以关联、合并、聚合多张表单的数据，得到输出表。',
        },
        {
          // items: [{id: '5', name: '聚合表1'}, {id: '6', name: '聚合表2'}],
          items: [],
          name: '聚合表',
          type: 'table',
          desc: '聚合表可以关联多张表单的数据，并实时计算。',
        },
      ],
    }
  },
  created() {
    this.getDataSources()
  },
  methods: {
    onClick(item) {
      this.form = {
        id: item.id,
        name: item.name,
        icon: '',
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onConfirm() {
      this.$emit('input', this.form)
    },
    getDataSources() {
      axios.get(zroute('app.dash.data_source', [zroute().params.app_id, zroute().params.dash_id])).then(res => {
        console.log(res.data)
        this.sources.forEach(source => {
          if (source.type === 'form') {
            source.items = res.data.forms
          } else if (source.type === 'flow') {
            // source.items = res.data.flows
          } else if (source.type === 'table') {
            // source.items = res.data.tables
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .tabs.el-tabs {
  .el-tabs__header {
    margin-bottom: 2px;
  }

  .el-tabs__nav-scroll {
    margin-left: 20px;
  }

  .el-tabs__content {
    height: calc(100% - 55px);

  }

  .el-tab-pane {
    max-height: 100%;
    overflow-y: auto;
  }
}
</style>
